module.exports = __webpack_public_path__ + "img/app_store_logo_ensfarget.04da34a.svg";